<template>
  <b-container>
    <b-row>
      <b-col md="5">
        <div>
          <h3 class="mt-4 heading">Diagnostic Center Name</h3>
          <b-row>
            <b-col md="1">
              <b-icon icon="pin-map" scale="1.5"></b-icon>
            </b-col>
            <b-col>
              <span
                >6, Blue Mount Compound, St. Michael Church Road, Mumbai,
                Maharastra</span
              >
            </b-col>
          </b-row>
        </div>
        <div>
          <b-row>
            <b-col md="1">
              <b-icon icon="phone" scale="1.5"></b-icon>
            </b-col>
            <b-col>
              <span>+91 987654321</span>
            </b-col>
          </b-row>
        </div>
        <div>
          <h3 class="mt-4 heading">About Center</h3>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iste
            reiciendis quasi minima, et dolorum nostrum explicabo nam
            perferendis voluptates labore aliquam accusantium pariatur sit
            incidunt quas sequi est nihil doloremque!
          </p>
        </div>

        <div>
          <h3 class="mt-4 heading">Available Tests</h3>
          <ul>
            <li>test1</li>
            <li>test2</li>
            <li>test3</li>
            <li>test4</li>
          </ul>
        </div>
      </b-col>
      <b-col offset="2" md="5">
        <div class="mt-3">
          <div class="image-icons">
            <div>
              <b-icon icon="heart" class="action-icon"></b-icon>
            </div>
            <div>
              <b-icon icon="share" class="action-icon"></b-icon>
            </div>
          </div>
          <b-carousel
            id="carousel-fade"
            style="text-shadow: 0px 0px 2px #000"
            fade
            indicators
            img-width="1024"
            img-height="480"
          >
            <b-carousel-slide
              caption=""
              img-src="https://picsum.photos/1024/480/?image=10"
            ></b-carousel-slide>
            <b-carousel-slide
              caption=""
              img-src="https://picsum.photos/1024/480/?image=12"
            ></b-carousel-slide>
            <b-carousel-slide
              caption=""
              img-src="https://picsum.photos/1024/480/?image=22"
            ></b-carousel-slide>
          </b-carousel>
        </div>
        <div>
          <h3 class="mt-3 heading">Rate & Reviews</h3>
          <div>
            <template>
              <div>
                <b-form-rating
                  class="review-star"
                  v-model="starValue"
                  readonly
                  variant="warning"
                  inline
                  no-border
                ></b-form-rating>
              </div>
            </template>
            <div>
              <p class="review-title">Good Service</p>
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Deleniti, asperiores.
              </p>
              <p class="reviewer">John George</p>
            </div>
            <hr />
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <sections-slider
          :list="itemSuggestions"
          subTitle="Related Packages"
          :showTitle="true"
          :hasBackground="false"
          :hasButton="true"
          class="suggested-slider"
          :withSlider="true"
          :viewMorePage="{
            name: `health-care-listing`,
            params: {
              items: `Most Popular`,
            },
          }"
        >
          <template slot="default" slot-scope="{ listItem }">
            <div class="item-box ml-2 mr- 2">
              <items-item
                :itemNoBg="true"
                :product="listItem"
                :incrementDecrementKey="true"
                class="suggester-div"
              ></items-item>
            </div>
          </template>
        </sections-slider>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="main-banner">
          <img
            :src="
              (diagnosticBanner.icon && diagnosticBanner.icon.fileUrl) || ''
            "
            alt="Diagnostic Centers Bottom Banner"
          />
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <sections-slider
          :list="itemSuggestions"
          subTitle="Recently Searched"
          :showTitle="true"
          :hasBackground="false"
          :hasButton="true"
          class="suggested-slider"
          :withSlider="true"
          :viewMorePage="{
            name: `health-care-listing`,
            params: {
              items: `Most Popular`,
            },
          }"
        >
          <template slot="default" slot-scope="{ listItem }">
            <div class="item-box ml-2 mr- 2">
              <items-item
                :itemNoBg="true"
                :product="listItem"
                :incrementDecrementKey="true"
                class="suggester-div"
              ></items-item>
            </div>
          </template>
        </sections-slider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return { starValue: 4.5 };
  },
  computed: {
    ...mapState({
      diagnosticBanner: (state) => state.healthCare.marketBanner,
    }),
  },
  async mounted() {
    this.isLoading = true;
    let payload = {
      city: "GHATAL",
      placement: "SHOP_TOP",
      provider: "62288a7d9e0dd452af89f0d1",
    };
    await this.$store.dispatch("healthCare/fetchMarketBanner", payload);

    this.isLoading = false;
  },
};
</script>

<style scoped>
.heading {
  font-weight: 600;
  font-size: 16px;
}
.image-icons {
    display: flex;
    flex-direction: column;
    position: absolute;
    z-index: 10;
    top: 40px;
    right: 24px;
}
.action-icon{
    height: 30px;
    width: 30px;
    padding: 5px;
    cursor: pointer;
    border-radius: 6px;
    background-color: #ffffff;
}
.review-title {
  font-weight: 500;
}
.reviewer {
  color: #9e9e9e;
}
.review-star {
  padding: 0px;
}
</style>
